<template>
    <v-app :style="colorVapp">
      <onebox_admin_toolbar
        :quicksearch="true"
        @loaddata="loaddata()"
        @loadfile="loadfolder()"
        @callstorage="loadstorage()"
        @closeDrag="removeEvent()"
        @openDrag="addEvent()"
      ></onebox_admin_toolbar>
      <v-content>
        <v-card class="elevation-0">
          <v-divider></v-divider>
          <v-overlay :value="processloader" absolute :color="color.BG" dark>
            <v-progress-circular indeterminate size="64" :color="color.theme"></v-progress-circular>
            <span :style="colorProgress">&nbsp; loading</span>
          </v-overlay>
  
          <!-- hearder -->
          <v-list nav :color="color.BG">
            <v-list-item class="text-left">
              <v-list-item-avatar class="text-center">
                <v-avatar :color="color.theme" size="35">
                  <v-icon dark size="20">mdi-account-cog</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <span :style="headerPage">&nbsp;{{ $t("admintoolbar.datagroup") }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card class="elevation-0" :color="color.BG" id="thiscontainersetadmin">
            <v-card-text class="pa-0">
              <v-container fluid>
                <v-layout row wrap justify-center fill-height>
                  <v-flex lg12 class="ma-2 ml-4 mr-4" v-if="loaddataprogress === true">
                    <div class="text-center">
                      <v-progress-circular :size="50" :color="color.theme" indeterminate></v-progress-circular>
                    </div>
                  </v-flex>
                  <v-flex lg12 class="ma-4" v-else>
                    <v-layout row wrap class="pl-3 pr-3">
                      <v-flex lg2 md4 xs9 class="mr-2">
                        <v-text-field
                          class="pl-1"
                          :label="$t('admin.search')"
                          v-model="search"
                          clearable
                          outlined
                          dense
                          :color="color.theme"
                          append-icon="search"
                          @click:clear="search = '',fn_load_group()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg1 xs2 class="pl-1">
                        <v-btn :color="color.theme" :dark="color.darkTheme" @click="fn_load_group(search), (clicksearch = true)">{{
                          $t("admin.search")
                        }}</v-btn>
                      </v-flex>
                      <!-- <v-flex>
                        <div class="text-right">
                          <v-btn
                            class="ma-3"
                            x-small
                            fab
                            :dark="color.darkTheme"
                            :color="color.theme"
                            @click="fn_reload(),showReload = false"
                            @mouseover="showReload = true"
                            @mouseleave="showReload = false"
                            ><v-icon small>mdi-reload</v-icon
                            ><v-badge :value="showReload"
                            style="z-index:10000;bottom:-45px;left:20px;" 
                            :content="$t('balloon.reload')" 
                            left
                            transition="slide-y-transition"
                            ></v-badge
                          ></v-btn>
                        </div>
                      </v-flex> -->
                    </v-layout>
                    <v-layout row wrap class="pl-3 pr-3">
                      <v-flex lg8 md8 xs8 class="mr-2">
                        <v-chip
                          class="ma-2"
                          :color="color.theme"
                          :text-color="color.chipText"
                        >
                          <v-icon left>mdi-account-group</v-icon>
                          {{ total_account }}
                          Group
                        </v-chip>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex lg3 md3 xs3 class="text-right">
                        <v-btn :color="color.theme" :dark="color.darkTheme" @click="fn_Add_group()">{{
                          $t("admin.addgroup")
                        }}</v-btn>
                      </v-flex>

                    </v-layout>
                    <!-- Phonee -->
                    <div v-if="loaddataprogresstable === true">
                      <v-flex lg12 class="ma-2 ml-4 mr-4">
                        <div class="text-center">
                          <!-- <v-progress-circular :size="50" :color="color.theme" indeterminate></v-progress-circular> -->
                          <v-skeleton-loader
                                class="mx-auto"
                                type="table"
                            ></v-skeleton-loader>
                        </div>
                      </v-flex>
                    </div>
                    <div v-else>
                      <div v-if="resolutionScreen < 500">
                        <v-list two-line class="mb-6 pb-6 elevation-0" v-if="this.total_account !== 0">
                          <v-list-item v-for="item in group" :key="item.title" style="cursor: pointer;">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.group_name"></v-list-item-title>
                              <!-- <v-list-item-title v-else v-text="item.user_name_en"></v-list-item-title> -->
                              <!-- <v-list-item-subtitle v-text="item.mobile"></v-list-item-subtitle> -->
                              <!-- <v-list-item-subtitle v-text="formatdatetime(item.process_dtm)"></v-list-item-subtitle> -->
                            </v-list-item-content>
                            <!-- <v-list-item-action>
                              <v-btn fab small text @click="open_employee(item)"><v-icon>settings</v-icon></v-btn>
                            </v-list-item-action> -->
                            <v-list-item-action>
                        <v-menu>
                          <template v-slot:activator="{ on }">
                              <v-btn class="elevation-0" fab small v-on="on">
                                <v-icon>more_vert</v-icon>
                              </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="open_employee(item)">
                                <v-list-item-icon>
                                  <v-icon>
                                    mdi-account-circle
                                  </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ $t("group_.dataemployee_") }}
                                  </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="fn_update_group(item)">
                                <v-list-item-icon>
                                  <v-icon>
                                    mdi-file-check
                                  </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ $t("group_.editdatagroup") }}
                                  </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="fn_delete_group(item)">
                                <v-list-item-icon>
                                  <v-icon>
                                    mdi-account-multiple-minus
                                  </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ $t("group_.deletegroup") }}
                                  </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
              </v-list-item-action>
                          </v-list-item>
                        </v-list>
                        <v-list v-else class="mb-6 pb-6 elevation-0">
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title class="text-center" v-text="$t('tablefile.empty')"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                      <!-- Labtop -->
                      <div v-else>
                        <v-data-table
                          :headers="$t('default') === 'en' ? headerEN : headerTH"
                          :items="group"
                          class="elevation-0"
                          :no-data-text="$t('tablefile.empty')"
                          :page.sync="page"
                          :items-per-page="size"
                          :hide-default-footer="true"
                          @page-count="pageCount = $event"
                        >
                          <template v-slot:[`header.id`]="{ header }">
                            <span class="pointer" :style="headerTable">{{ $t(header.text) }}</span>
                          </template>
                          <template v-slot:[`header.group_name`]="{ header }">
                            <span class="pointer" :style="headerTable">{{ $t(header.text) }}</span>
                          </template>
                          <template v-slot:[`header.status`]="{ header }">
                            <span class="pointer" :style="headerTable">{{ $t(header.text) }}</span>
                          </template>
  
                          <template v-slot:item="props">
                            <tr>
                              <td width="7%" class="text-center">
                                <v-icon v-if="props.item.status_admin === true" :color="color.theme">mdi-account-star</v-icon>
                                <v-icon v-else>mdi-account</v-icon>
                              </td>
                              <td width="43%" >{{ props.item.group_name }}</td>
                              <!-- <td width="40%">{{ props.item.mobile }}</td> -->
                              <!-- <td width="10%" class="text-center">
                                <v-btn fab small text @click="open_employee(props.item)"><v-icon>settings</v-icon></v-btn>
                              </td> -->
                              <td width="10%" class="text-center">
                            <v-menu>
                              <template v-slot:activator="{ attrs, on }">
                                <v-btn class="elevation-0" fab small v-bind="attrs" v-on="on">
                                  <v-icon>settings</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item link @click="open_employee(props.item)">
                                  <v-list-item-icon>
                                    <v-icon>mdi-account-circle</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ $t("group_.dataemployee_") }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item link @click="fn_update_group(props.item)">
                                  <v-list-item-icon>
                                    <v-icon>mdi-file-check</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ $t("group_.editdatagroup") }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item link @click="fn_delete_group(props.item)">
                                  <v-list-item-icon>
                                    <v-icon>mdi-account-multiple-minus</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ $t("group_.deletegroup") }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <!-- <v-list-item link @click="goto_create_manageDepartment(props.item.id)" >
                                  <v-list-item-icon>
                                    <v-icon>mdi-folder-heart</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>Manage Department</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item link @click="goto_set_template_invoice(props.item)">
                                  <v-list-item-icon>
                                    <v-icon>mdi-file-cog-outline</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>Set Template Invoice</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item> -->
                              </v-list>
                            </v-menu>
                          </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </div>
                      <br />
                      <!-- <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :color="color.theme"
                        :total-visible="10"
                        @input="clickpagination()"
                      ></v-pagination> -->
                      <v-layout row wrap justify-center>
                        <v-flex xs11 lg11 v-if="pageCount > 0">
                          <v-pagination
                            :total-visible="10"
                            v-model="page"
                            :length="pageCount || 0"
                            :color="color.theme"
                            @input="clickpagination()"
                          ></v-pagination>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
          <dialogdataemployee
            :show="opendialogdataemployee"
            @close="opendialogdataemployee = false"
            :data_group="data_group"
          ></dialogdataemployee>
          <dialogaddgroup
            :show="opendialogaddgroup"
            @close="opendialogaddgroup = false"
            @reload="opendialogaddgroup = false ,fn_load_group() "
          ></dialogaddgroup>
          <dialogupdategroup
            :show="opendialogupdategroup"
            @close="opendialogupdategroup = false"
            @reload="opendialogupdategroup = false ,fn_load_group() "
            :dataupdategroup="dataupdategroup"
          ></dialogupdategroup>
          <dialogdeletegroup
            :show="opendialogdeletegroup"
            @close="opendialogdeletegroup = false"
            @reload="opendialogdeletegroup = false ,fn_load_group() "
            :datagroup="datagroup"
          ></dialogdeletegroup>
        </v-card>
      </v-content>
    </v-app>
  </template>
  <script>
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import { mapState, mapGetters } from "vuex";
  import "vue-full-screen-file-drop/dist/vue-full-screen-file-drop.css";
  import onebox_admin_toolbar from "../components/layout/layout-admin-toolbar";
  import gbfGenerate from "../globalFunctions/generateAuthorize";
  
//   const managemydrive = () => import("../components/optional/dialog-admin-mydrive");
  const dialogdataemployee = () => import("../components/optional/dialog-data-employeeingroup.vue")
  const dialogaddgroup = () => import("../components/optional/dialog-addgroup.vue")
  const dialogupdategroup = () => import("../components/optional/dialog-updategroup.vue") 
  const dialogdeletegroup = () => import("../components/optional/dialog-deletegroup.vue")

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
  });
  export default {
    components: {
      onebox_admin_toolbar,
      dialogdataemployee,
      dialogaddgroup,
      dialogupdategroup,
      dialogdeletegroup
    },
    data: function() {
      return {
        datagroup:{},
        opendialogdeletegroup:false,
        dataupdategroup:{},
        opendialogupdategroup:false,
        opendialogaddgroup: false,
        showReload: false,
        data_group:{},
        opendialogdataemployee:false,
        items_department:[],
        selectdepartment:"",
        clicksearch: false,
        staff: [],
        group:[],
        total_account: 0,
        loaddataprogresstable: false,
        search: "",
        detaildata: {},
        loaddataprogress: true,
        size: 10,
        offset: 0,
        page: 1,
        x: 0,
        y: 0,
        listsize: [10, 20, 50, 100],
        headerTH: [
          {
            text: "#",
            align: "center",
            value: "id",
            width: "7%",
            sortable: false,
          },
          {
            text: "adminlog.name_group",
            align: "",
            value: "group_name",
            width: "43%",
            sortable: false,
          },
        //   {
        //     text: "admin.tel",
        //     align: "",
        //     value: "department_name",
        //     width: "43%",
        //     sortable: false,
        //   },
          {
            text: "admin.setting_group",
            align: "center",
            value: "status",
            width: "7%",
            sortable: false,
          },
        ],
        headerEN: [
          {
            text: "#",
            align: "center",
            value: "id",
            width: "7%",
            sortable: false,
          },
          {
            text: "adminlog.name_group",
            align: "",
            value: "group_name",
            width: "43%",
            sortable: false,
          },
        //   {
        //     text: "admin.tel",
        //     align: "",
        //     value: "department_name",
        //     width: "43%",
        //     sortable: false,
        //   },
          {
            text: "admin.setting_group",
            align: "center",
            value: "status",
            width: "7%",
            sortable: false,
          },
        ],
      };
    },
    computed: {
      ...mapState(["username", "authorize", "account_active", "service", "color"]),
      ...mapState({ processloader: "loading" }),
      ...mapGetters([
        "dataUsername",
        "dataAuthorize",
        "dataAccountActive",
        "dataAccesstoken",
        "dataBusinessProfile",
        "dataCitizenProfile",
        "dataDepartmentAccessId",
        "dataAccountId",
        "dataStorageUsage",
        "dataStorageMax",
      ]),
      resolutionScreen() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return 220;
          case "sm":
            return 400;
          case "md":
            return 500;
          case "lg":
            return 600;
          case "xl":
            return 800;
        }
      },
      pageCount: {
        get() {
          let l = this.total_account;
          let s = this.size;
          return Math.ceil(l / s);
        },
        set(newName) {
          return newName;
        },
      },
      headerTable() {
        return "color:" + this.color.theme + ";" + "font-weight: 600; font-size:15px;";
      },
      headerPage() {
        // console.log(this.color.theme);
  
        return "color:" + this.color.theme + ";" + "font-size: 18px; font-weight: 600;";
      },
      colorVapp() {
        return "background:" + this.color.BG + ";";
      },
      colorSort() {
        return "color:" + this.color.alertText + ";";
      },
      colorProgress() {
        return "color:" + this.color.theme + ";";
      },
    },
    methods: {
      fn_delete_group(data){
        this.opendialogdeletegroup = true;
        this.datagroup = data;
      },
      fn_update_group(data){
        this.opendialogupdategroup = true;
        this.dataupdategroup = data;
      },
      fn_Add_group(){
        this.opendialogaddgroup = true;
      },
      fn_reload(){
        this.loaddataprogresstable = true;
        this.staff = [];
        let cal_limit = this.size;
        let cal_offset = this.size * (this.page - 1);
        var payload = {
          business_id: this.dataAccountActive.business_info.business_id,
          account_admin: this.dataAccountId,
          department_id:this.selectdepartment || "",
          search_key:this.search || "",
          limit: cal_limit,
          offset: cal_offset,
        };
        console.log(this.clicksearch);
        this.axios
          .post(process.env.VUE_APP_SERVICE_ADMIN + "/api/admin/update_data_byoneID", payload)
          .then((response) => {
            console.log("get", response);
            if (response.data.status === "OK") {
              this.total_account = response.data.count;
              this.loaddataprogresstable = false;
              for (let i = 0; i < response.data.result.length; i++) {
                let datastaff = {};
                datastaff["account_folder_id"] = response.data.result[i]["account_folder_id"];
                datastaff["account_id"] = response.data.result[i]["account_id"];
                datastaff["mobile"] = response.data.result[i]["mobile"];
                datastaff["oneid_user_id"] = response.data.result[i]["oneid_user_id"];
                datastaff["user_id"] = response.data.result[i]["user_id"];
                datastaff["user_name_en"] = response.data.result[i]["user_name_en"];
                datastaff["user_name_th"] = response.data.result[i]["user_name_th"];
                this.staff.push(datastaff);
                //this.loaddataprogresstable = false;
              }
            } else {
               Toast.fire({
                icon: "error",
                title: response.data.errorCode + ': ' + response.data.errorMessage,
              });
              this.loaddataprogresstable = false;
            }
          })
          .catch((error) => {
            console.log(error);
            Toast.fire({
              icon: "error",
              title: this.$t("toast.cannotconnectonebox"),
            });
            this.loaddataprogresstable = false;
          });
      },
      //เปลี่ยนหน้า
      clickpagination() {
        console.log(this.search, this.clicksearch);
        if (this.search !== null && this.search.length !== 0 && this.clicksearch === true) {
          this.fn_load_group();
        } else {
          this.fn_load_group();
        }
      },
      open_employee(group){
        this.opendialogdataemployee = true
        //   this.opendialogmydrive = true
        //   console.log(this.opendialogmydrive);
          this.data_group =group
      },
      async fn_load_group(search){
        this.group = [];
        this.loaddataprogresstable = true;
        let cal_limit = this.size;
        let cal_offset = this.size * (this.page - 1);
        var payload = {
          account_id:this.dataAccountId,
          business_id:this.dataAccountActive.business_info.business_id,
          // search:"search",
          limit: cal_limit,
          offset: cal_offset,
        };
        let auth = await gbfGenerate.generateToken();
        this.axios
        //   .post(process.env.VUE_APP_SERVICE_ADMIN + "/api/admin/get_group_business", payload,{
            .post(" https://f9300388b7d4.ngrok-free.app/api/admin/get_group_business", payload,{
              headers: { Authorization: auth.code },})
          .then((response) => {
            if (response.data.status === "OK") {
              console.log("ge11t", response);
              this.total_account = response.data.total;
              this.loaddataprogresstable = false;
              for (let i = 0; i < response.data.list_group_business.length; i++) {
                let datagroup = {};
                datagroup["business_id"] = response.data.list_group_business[i]["business_id"];
                datagroup["group_name"] = response.data.list_group_business[i]["group_name"];
                datagroup["id"] = response.data.list_group_business[i]["id"];
                this.group.push(datagroup);
                this.loaddataprogresstable = false;
              }
            } else {
               Toast.fire({
                icon: "error",
                title: response.data.errorCode + ': ' + response.data.errorMessage,
              });
              this.loaddataprogresstable = false;
            }
          })
          .catch((error) => {
            console.log(error);
            Toast.fire({
              icon: "error",
              title: this.$t("toast.cannotconnectonebox"),
            });
            this.loaddataprogresstable = false;
          });
      },
      //ค้นหาชื่อพนักงาน
     async fn_search_staff(parameter) {
        this.loaddataprogresstable = true;
        this.staff = [];
        let cal_limit = this.size;
        let cal_offset;
        if (parameter === "c") {
          cal_offset = this.size * (this.page - 1);
        } else {
          cal_offset = 0;
          this.page = 1;
        }
        var payload = {
          business_id: this.dataAccountActive.business_info.business_id,
          search: this.search,
          limit: cal_limit,
          offset: cal_offset,
        };
        //console.log(payload);
        //console.log(this.clicksearch);
        let auth = await gbfGenerate.generateToken();
       await this.axios
          .post(process.env.VUE_APP_SERVICE_DOWNLOAD_API + "/api/search_account_in_business", payload,{
              headers: { Authorization: auth.code },})
          .then((response) => {
            console.log("get", response);
            if (response.data.status === "OK") {
              this.total_account = response.data.total;
              if(response.data.total === 0){
               this.staff = [];
               this.loaddataprogresstable = false;
              }else{
              for (let i = 0; i < response.data.account.length; i++) {
                let datastaff = {};
                datastaff["staff_id"] = response.data.account[i]["id"];
                datastaff["name_eng"] = response.data.account[i]["name_eng"];
                datastaff["name_th"] = response.data.account[i]["name_th"];
                datastaff["department_name"] = response.data.account[i]["department"];
                datastaff["status_admin"] = this.settoboolean(response.data.account[i]["admin_business_status"]);
                this.staff.push(datastaff);
                this.loaddataprogresstable = false;
              }
              }
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.errorCode + ': ' + response.data.errorMessage,
              });
              this.loaddataprogresstable = false;
            }
            console.log(this.staff);
          })
          .catch((error) => {
            // console.log(error);
            Toast.fire({
              icon: "error",
              title: this.$t("toast.cannotconnectonebox"),
            });
            this.loaddataprogresstable = false;
          });
      },
    },
    mounted() {
      this.fn_load_group();
      this.loaddataprogress = false;
    },
  };
  </script>
  <style>
  #thiscontainersetadmin {
    height: calc(101vh - 180px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -moz-overflow-scrolling: touch;
    -ms-overflow-scrolling: touch;
  }
  </style>
  